import { MeasurementName } from '@quromedical/models';
import { compact } from '@quromedical/utils';
import { interpret } from './interpreter';
const referenceMeasures = [MeasurementName.GlucoseBeforeMeal, MeasurementName.GlucoseAfterMeal, MeasurementName.GlucoseFasting];

const resolveGlucose = (_, windowVitals) => {
  const values = referenceMeasures.map(type => windowVitals[type]);
  return compact(values).map(value => ({ ...value,
    type: MeasurementName.Glucose
  }));
};

const configurations = referenceMeasures.map(base => ({
  base,
  resolve: resolveGlucose
}));
export const calculateGlucose = interpret(configurations);
//# sourceMappingURL=glucose.js.map